import React, { useContext } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import FactoryContext from "../../contexts/factoryContext";
import useGames from "../../hooks/queryResults/useGames";
import useTeam from "../../hooks/queryResults/useTeam";
import Loading from "../ui/Loading";

/**
 *
 * @returns {JSX.Element}
 */
export default function TeamGamesTable() {
  const factory = useContext(FactoryContext);
  const { team } = useTeam();
  const { gamesCollection: allGames } = useGames();
  const breakpoints = useContext(BreakpointContext);

  const loaded =
    factory && team && team.hasLoaded() && allGames && allGames.hasLoaded();

  const getHeaderRow = () => {
    let weekHeader = "Week";
    let oppHeader = "Opponent";
    let resultHeader = "Result";
    let oppColSpan = 2;
    if (!breakpoints.sm) {
      weekHeader = <span title={"Week"}>Wk</span>;
      oppHeader = <span title={"Opponent"}>Opp</span>;
      resultHeader = <span title={"Result"}>Res</span>;
      oppColSpan = 1;
    }

    return (
      <tr>
        <th>{weekHeader}</th>
        <th>&nbsp;</th>
        <th colSpan={oppColSpan}>{oppHeader}</th>
        <th>{resultHeader}</th>
      </tr>
    );
  };

  const getOppRow = (week) => {
    let game = teamGames[week];

    let vs = "";
    let oppLogo = "";
    let opp = breakpoints.md ? "bye week" : "bye";
    let result = "";

    if (game) {
      vs = game.getVsForTeam(teamId);

      const oppGameTeam = game.getOppGameTeam(teamId);
      const oppTeam = oppGameTeam.team;
      let oppLogos = factory.makeTeamLogoCollection(oppTeam);
      oppLogo = oppLogos.getActiveLogo()?.getImgSm();

      let oppLinkLabel = breakpoints.md ? undefined : (
        <span title={oppTeam.fullName}>{oppTeam.obj.abbr}</span>
      );
      opp = oppTeam.getLink(oppLinkLabel);

      const size = breakpoints.md ? "lg" : "sm";
      result = game.getResultText(teamId, size);
    }

    const oppCell = breakpoints.sm ? <td className={"left"}>{opp}</td> : null;

    return (
      <tr key={week}>
        <td className={"center"}>{week}</td>
        <td>{vs}</td>
        <td>{oppLogo}</td>
        {oppCell}
        <td>{result}</td>
      </tr>
    );
  };

  const headerRow = getHeaderRow(breakpoints);

  let teamId, teamGames;
  let weeks = [];
  if (loaded) {
    teamId = team.obj.id;
    teamGames = allGames.getGamesByTeam(teamId);
    weeks = Object.keys(teamGames);
  }

  return !loaded ? (
    <Loading />
  ) : (
    <table className={"standard"}>
      <thead>{headerRow}</thead>
      <tbody>{weeks.map(getOppRow)}</tbody>
    </table>
  );
}
